import {faPlus, faTrashAlt} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';
import {Col, Form, Row, InputGroup} from 'react-bootstrap';
import {Help} from '../buttons';
import sortBy from 'lodash/sortBy';

export type OffsetRange = {
  offset: number;
  value: number | string;
};

export type OffsetRangesProps = {
  min?: number;
  max?: number;
  ranges: OffsetRange[];
  defaultRange?: OffsetRange;
  onChange: (ranges: OffsetRange[]) => void;
  control: React.ComponentType<{
    value: number | string;
    onChange: (value: number | string) => void;
  }>;
  controlTitle: string;
};

export const OffsetRanges: React.FC<OffsetRangesProps> = (props) => {
  const {
    min = 0,
    max = 100,
    ranges,
    onChange,
    controlTitle,
    control,
    defaultRange,
  } = props;
  const [newRange, setNewRange] = React.useState<OffsetRange>(
    defaultRange || ranges[0]
  );

  const isNewRangeValid = newRange.offset <= 100 && newRange.offset >= 0;

  return (
    <>
      <Row>
        <Col sm={2}>Offset (0 - 100%)</Col>
        <Col sm={3}>{controlTitle}</Col>
      </Row>
      {ranges.map((range, index) => {
        const isValid = range.offset <= 100 && range.offset >= 0;

        return (
          <Form.Group key={index} as={Row}>
            <Col md={2}>
              <InputGroup>
                <Form.Control
                  type="number"
                  value={range.offset}
                  min={min}
                  max={max}
                  isInvalid={!isValid}
                  onChange={(evt) => {
                    const newRanges = [...ranges];
                    newRanges[index] = {
                      ...newRanges[index],
                      offset: Number(evt?.target?.value),
                    };
                    onChange(newRanges);
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  Offset must be between 0 and 100
                </Form.Control.Feedback>
              </InputGroup>
            </Col>
            <Col sm="3">
              {React.createElement(control, {
                value: range.value,
                onChange: (value: number | string) => {
                  const newRanges = [...ranges];
                  newRanges[index] = {
                    ...newRanges[index],
                    value,
                  };
                  onChange(newRanges);
                },
              })}
            </Col>
            <Col sm={3}>
              <Help
                onClick={() => {
                  const newRanges = ranges.filter((_, i) => i !== index);
                  onChange(newRanges);
                }}
              >
                <FontAwesomeIcon icon={faTrashAlt as any} />
              </Help>
            </Col>
          </Form.Group>
        );
      })}

      <hr />
      <Form.Group as={Row}>
        <Col sm={2}>
          <InputGroup>
            <Form.Control
              type="number"
              value={newRange?.offset}
              min={min}
              max={max}
              onChange={(evt) => {
                setNewRange({...newRange, offset: Number(evt?.target?.value)});
              }}
              isInvalid={!isNewRangeValid}
            />

            <Form.Control.Feedback type="invalid">
              Offset must be between 0 and 100
            </Form.Control.Feedback>
          </InputGroup>
        </Col>
        <Col sm="3">
          {React.createElement(control, {
            value: newRange?.value,
            onChange: (value) => {
              setNewRange({...newRange, value});
            },
          })}
        </Col>
        <Col sm={3}>
          <Help
            disabled={!isNewRangeValid}
            onClick={() => {
              const newRanges = sortBy([...ranges, newRange], 'offset');
              onChange(newRanges);

              setNewRange({
                offset: Math.min(newRange.offset + 1, 100),
                value: defaultRange?.value || newRange.value,
              });
            }}
          >
            <FontAwesomeIcon icon={faPlus as any} />
          </Help>
        </Col>
      </Form.Group>
    </>
  );
};
